<template>
	<div>

	<el-container class="data_skc">

		<el-aside class="aside-style" width="200px">
			<common-nav selec="1-1"></common-nav>
		</el-aside>
		
		<el-container>

			<el-header class="common_header">
				<common-header></common-header>
			</el-header>
			
			<el-main>

				<el-row :gutter="24" class="page_bar">
					<el-col :span="10" class="page_bar_title">活动列表</el-col>
					<el-col :span="8" style="text-align: right;">
						<el-button icon="el-icon-document-checked" type="success" size="small" @click="handleShowNewSingup">新建活动</el-button>
						<el-button icon="el-icon-refresh-right" type="primary" size="small" @click="handleRefreshList">刷新列表</el-button>
					</el-col>
					<el-col :span="6">
						<el-input placeholder="输入关键词搜索" v-model="searchValue" class="input-with-select" size="small" >
							<el-button slot="append" icon="el-icon-search" @click="handleGoSearch"></el-button>
						</el-input>
					</el-col>
				</el-row>

				<el-table v-loading="loading" :data="tableData" size="medium" stripe highlight-current-row>
					<el-table-column prop="status" label="状态" width="80" >
						<template slot-scope="scope">
							<label v-if="scope.row.status == 1" style="color:green">正常</label>
							<label v-if="scope.row.status == 0" style="color:red">结束</label>
						</template>
					</el-table-column>
					<el-table-column prop="topics_type" label="活动类型" width="80" >
						<template slot-scope="scope">
							<!-- <label v-if="scope.row.topics_type == 1" >报名</label>
							<label v-if="scope.row.topics_type == 2" >评审</label>
							<label v-if="scope.row.topics_type == 3" >报名</label>
							 -->
							<label v-if="scope.row.topics_singup_type == 'pp'" >品牌活动</label>
							<label v-if="scope.row.topics_singup_type == 'px'" >培训活动</label>
							
						</template>
					</el-table-column>
					<el-table-column prop="topics_name" label="活动名称"></el-table-column>
					<el-table-column prop="introduction" label="活动简介">
						<template slot-scope="scope">
						{{ scope.row.introduction==null?'':(scope.row.introduction.length>100?scope.row.introduction.substring(0,40)+'...':scope.row.introduction) }}
						</template>
					</el-table-column>
					<!-- <el-table-column label="活动链接">
						<template slot-scope="scope"><a target="_blank" :href="'https://www.subudian.com/#/singup?uid=' + scope.row.topics_link">https://www.subudian.com/#/singup?uid={{scope.row.topics_link}}</a></template>
					</el-table-column> -->
					<el-table-column label="二维码" width="80" >
						<!-- <template slot-scope="scope"> -->
						<template slot-scope="scope">
							<el-popover 
								placement="left-start"
								title="此活动二维码"
								width="200"
								trigger="hover">
								<img v-if="scope.row.topics_qrcode" :src="'https://api.subudian.com/uploads/' + scope.row.topics_qrcode + '.png'" width="200px">
								<img v-if="!scope.row.topics_qrcode"  src="https://api.subudian.com/uploads/default_code.jpg" width="200px">
								<i class="el-icon-copy-document" style="font-size:20px" slot="reference"></i>
							</el-popover>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="create_user" width="90" label="所属部门" ></el-table-column> -->
					<el-table-column prop="create_user_name" width="90" label="创建账户" ></el-table-column>
					<el-table-column label="操作" width="220">
						<template slot-scope="scope">
							<!-- <el-button type="success" v-if="scope.row.status == 0" @click="handleOpenTopics(scope.row)" size="mini" plain>开启</el-button>
							<el-button type="warning" v-if="scope.row.status == 1" @click="handleCloseTopics(scope.row)" size="mini" plain>关闭</el-button>
							<el-button type="primary" @click="handleEditTopics(scope.row)" size="mini" plain>修改</el-button> -->
							<el-button type="primary" @click="handleTopicsDetail(scope.row)" size="mini" plain>详情</el-button>
							<el-button type="primary" @click="handleSetTopicsToFile(scope.row)" size="mini" plain>归档</el-button>
							<el-button type="danger" @click="handleDelTopics(scope.row)" size="mini" plain>删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<el-pagination
					background
					layout="prev, pager, next"
					:total="10" class="page_pagination">
					</el-pagination>
				</el-main>

			<el-footer> copyright &copy; subudian.com </el-footer>
		</el-container>
	</el-container>


	<el-dialog :title="dialogSingupTitle" :visible.sync="dialogSingupDataVisible">

		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动类型：
				<el-radio v-model="topics_singup_type" label="px">培训活动</el-radio>
  				<el-radio v-model="topics_singup_type" label="pp">品牌活动</el-radio>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动名称：
				<el-input type="text" size="small" v-model="input_singup_title" maxlength="200" show-word-limit placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="sixo">
			<el-col :span="7">
				<el-switch v-model="switch_room" active-value="y" inactive-value="n" active-color="#13ce66" active-text="开启住宿选项"></el-switch>
			</el-col>
			<el-col :span="9">
				<el-switch v-model="switch_is_self_edit" active-value="y" inactive-value="n" active-color="#13ce66" active-text="用户可修改提交的内容"></el-switch>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="sixo">
			<el-col :span="24">活动简介：
				<el-input type="textarea" :rows="6" size="small" v-model="input_singup_introduction" maxlength="6000" show-word-limit placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动日期：
				<el-date-picker
					v-model="topics_date"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期" size="medium"  value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width: 99%;">
				</el-date-picker>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动日期提示（会显示到报名页面上）：
				<el-input type="text" size="small" v-model="topics_date_tips" maxlength="200" show-word-limit placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="sixo" v-if="check_power == '2'" >
			<el-col :span="24">
				将活动指派给（此选项超管权限可见，普通用户只能创建自己的活动）：
				<el-select size="small"  v-model="input_singup_user_uuid" placeholder="请选择">
					<el-option
					v-for="item in user_list"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
				</el-select>
			</el-col>
		</el-row>
		
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogSingupDataVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleSaveSingupData">确 定</el-button>
		</div>
	</el-dialog>


	</div>
</template>

<script>

import CommonNav from "@/components/Nav.vue";
import CommonHeader from "@/components/Header.vue";

import * as MN from '@/api/common'

export default {
    name: 'topics', 
	props:['selec'],
	data() {
		return {
			switch_is_self_edit:'n',
			switch_room:'y',
			topics_date_tips:'',
			topics_date:[],
			check_power:0,
			input_singup_user_uuid:'',
			topics_singup_type:'',
			input_singup_title:'',
			input_singup_introduction:'',
			edit_singup_uuid:'',
			searchValue:'',
			loading:true,
			boxshow: false, 
			curTipsID: '', 
			tableData: [],
			dialogSingupTitle:'',
			dialogSingupDataVisible:false,
			user_list:[
				{value: '男',label: '男'},
				{value: '女',label: '女'},
			],
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now(); 
				}
			},
		}
	},
	components: {
		CommonNav,
		CommonHeader
	},

	created() {
		this.initData()
		
	},
	mounted() {

	},
	methods: {

		handleSetTopicsToFile(rowdata){
			this.$confirm('确定要将此活动设为归档吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topic_uuid:rowdata.uuid
				}
				MN.setTopicsToFile(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleRefreshList(){
			this.initData()
		},
		handleGoSearch(){
			let me = this;
			if ( !this.searchValue ){
				this.$message({
				message: '请输入搜索内容',
				type: 'warning'
				});
				return
			}
			let post={
				token:sessionStorage.getItem('subudian_token'),
				keyword:me.searchValue
			}
			MN.searchNormalTopic(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.tableData=res.data;
				me.$message({
					type: 'success',
					message: '已返回搜索结果'
				});
			})
		},
		handleSaveSingupData(){

			if( !this.topics_singup_type ){
				this.$message({
				message: '请选择活动类型',
				type: 'warning'
				});
				return
			}


			if( !this.input_singup_title ){
				this.$message({
				message: '请填写标题',
				type: 'warning'
				});
				return
			}

			if( !this.topics_date || this.topics_date.length == 0 ){
				this.$message({
				message: '请选择活动日期',
				type: 'warning'
				});
				return
			}

			if( !this.topics_date_tips ){
				this.$message({
				message: '请填写日期提醒',
				type: 'warning'
				});
				return
			}

			let post={
				token:sessionStorage.getItem('subudian_token'),
				singup_title:this.input_singup_title,
				singup_introduction:this.input_singup_introduction,
				edit_singup_uuid:this.edit_singup_uuid,
				singup_user_uuid:this.input_singup_user_uuid,
				topics_date_tips:this.topics_date_tips,
				topics_start_date:this.topics_date[0],
				topics_end_date:this.topics_date[1],
				switch_room:this.switch_room,
				switch_is_self_edit:this.switch_is_self_edit,
				topics_singup_type:this.topics_singup_type
			}
			let me = this;
			MN.setSaveSingupData(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				if( res.status == 'add_ok' ){	
					me.$message({
						message: '创建成功',
						type: 'success'
					});
				}

				if( res.status == 'edit_ok' ){	
					me.$message({
						message: '修改成功',
						type: 'success'
					});
				}

				me.dialogSingupDataVisible = false;
				me.initData();
			})

		},
		handleOpenTopics(rowdata){
			this.$confirm('打开后将继续报名活动', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topic_uuid:rowdata.uuid
				}
				MN.setOpenTopics(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleCloseTopics(rowdata){
			this.$confirm('关闭后将停止报名活动', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topic_uuid:rowdata.uuid
				}
				MN.setCloseTopics(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleEditTopics(rowdata){
			this.getUserList();
			this.check_power=0;
			this.edit_singup_uuid = rowdata.uuid;
			this.input_singup_title = rowdata.topics_name;
			this.input_singup_introduction = rowdata.introduction;
			this.dialogSingupTitle = '修改报名活动';
			this.dialogSingupDataVisible = true;
		},
		handleTopicsDetail(rowdata){
			this.$router.push('/topics/detail?uuid='+rowdata.uuid)
		},
		handleDelTopics(rowdata){
			this.$confirm('删除后活动将不可访问，并移动到回收站，确定吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'danger'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topic_uuid:rowdata.uuid
				}
				MN.setDelTopics(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleShowNewSingup(){
			this.getUserList();
			this.edit_singup_uuid = '';
			this.check_power=0;
			this.input_singup_user_uuid= '';
			this.topics_singup_type = '';
			this.input_singup_title= '';
			this.input_singup_introduction= '';
			this.dialogSingupTitle = '新建报名活动';
			this.dialogSingupDataVisible = true;
		},
		getUserList(){
			let me = this;
			this.loading = true
			let post={
				token:sessionStorage.getItem('subudian_token')
      		}
			MN.getUserDataList(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.check_power = res.upower;
				let templist = [];
				for(let i=0; i < res.userlist.length; i++ ){
					templist.push({
						'value':res.userlist[i].uuid,
						'label':res.userlist[i].nickname
					});  
				}
				me.user_list=templist;
				me.loading=false;
			})
		},
		initData(){
			let me = this;
			this.loading = true
			let post={
				token:sessionStorage.getItem('subudian_token')
     		}
			MN.getTopicsList(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				this.tableData=res.data;
				this.loading=false;
			})
		},
	}
}
</script>

<style scoped>
.sixso{ margin-bottom: 20px; font-size: 14px; color: #d0d0d0; }
.sixso strong{ color: #6991c2; }
.sixo{ margin-top:15px; }
.red_dot{ color: #ff693f; }
.xootips{ color: #a9a9a9; margin-top: 4px; }
</style>